import { useEffect } from 'react';

function useOnClickOutside(target, active, callback) {
    useEffect(() => {
        if (!active) {
            return;
        }

        function onClickBody(e) {
            if (target.current == null || target.current.contains(e.target)) {
                return;
            }

            e.preventDefault();
            e.stopPropagation();

            callback();
        }

        document.addEventListener('mousedown', onClickBody);

        return () => {
            document.removeEventListener('mousedown', onClickBody);
        };
    }, [active, target, callback]);
}

export { useOnClickOutside };
